import React, { createRef, Fragment, useState } from 'react'
import { styled, useTheme } from '@mui/system'
import AttendanceTable from './shared/AttendanceTable'
import {
    Grid,
    Card,
    TextField,
    Box,
    CardMedia,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    Stack,
    IconButton,
    Button,
    Icon,
} from '@mui/material'
import { ShiftPicker } from 'app/components'
import Paper from '@mui/material/Paper'
import { SectionTitle } from 'app/components'
import { useDispatch, useSelector } from 'react-redux'
import { getMeasurements } from 'app/redux/actions/WorkerActions'
import {
    getCompany,
    getForeman,
    getLocation,
    getJob,
} from 'app/redux/actions/UtilsActions'
import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import AddMeasurementMenu from './shared/AddMeasurementMenu'
import axios from 'axios.js'
import moment from 'moment'

const ContentBox = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
}))
const ContainerBox = styled(Paper)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    borderRadius: '5px',
    backgroundColor: '#fff',
    padding: '13px 26px',
    marginBottom: '10px',
}))
const H1 = styled('h1')(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: '500',
    marginBottom: '16px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
}))

const Label = styled('dt')(({ theme }) => ({
    float: 'left',
    clear: 'left',
    width: '7em',
    fontWeight: 'bold',
}))

const Data = styled('dd')(({ theme }) => ({
    float: 'left',
}))

const CardHeader = styled('div')(() => ({
    paddingLeft: '24px',
    paddingRight: '24px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}))

const TableData = styled(Typography)(() => ({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
}))

const ProductTable = styled(Table)(() => ({
    minWidth: 400,
    whiteSpace: 'pre',
    '& small': {
        height: 15,
        width: 50,
        borderRadius: 500,
        boxShadow:
            '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
    },
    '& td': {
        borderBottom: 'none',
    },
    '& td:first-of-type': {
        paddingLeft: '16px !important',
    },
}))

const getLocaleISODateFormat = (d) => {
    var offset = -d.getTimezoneOffset() * 60 * 1000
    return new Date(d.getTime() + offset).toISOString().split('T')[0]
}

const ADD_WORKER_MEASUREMENT_PATH = {
    api: {
        worker: {
            measurements: {
                set:{
                    _queries:{
                        cid:{},
                        shift:{},
                        date:{}
                    }
                }
            }
        }
    }
}

const ADD_WORKER_MEASUREMENT_API_URL = '/api/worker/measurements/set'

const UserInfo = () => {
    const [params, setParams] = useSearchParams()
    const [addMeasurmentOpen, setAddMeasurmentOpen] = useState(false)

    const addMeasurmentClose = (rs) => {
        if (rs !== null) {
            //{"shift":shift, "date":date, "values":{parameter:detected?"1":"0"}}
            addMeasurement(rs['shift'], rs['date'], [rs['values']])
        }
        setAddMeasurmentOpen(false)
    }

    const addMeasurmentShow = () => {
        setAddMeasurmentOpen(true)
    }

    const dispatch = useDispatch()
    const { measurments } = useSelector((state) => state.worker)
    const [userLoaded, setUserLoaded] = useState(false)

    const cid = params.get('cid') //.getParam('cid', 'NO-ID');

    const shift = params.get('shift')
    const date = params.get('date')

    

    const createFilter = () => {
        let dv = new Date().getTime()
        let cv = 'Nodata'
        try {
            dv = parseInt(date, 10)
            cv = cid
        } catch {}
        let search = {
            search: cv + '',
            shift: shift,
            shift_date: moment(dv).format("YYYY-MM-DD"),
        }
        return { ...search }
    }

    if (!userLoaded) {
        dispatch(getMeasurements(createFilter()))

        setUserLoaded(true)
    }

    const addMeasurement = (shift, date, values) => {
        //let imagefile = document.querySelector('#file');
        //formData.append("image", imagefile.files[0])
        if(cid!==null && /^[0-9a-zA-Z]+$/.test(cid) && shift!==null && date!==null){
            const dtString = getLocaleISODateFormat(date)

            axios
                .post(ADD_WORKER_MEASUREMENT_API_URL, values, {params: {"cid":cid,"shift":shift,"date":dtString}})
                .then((res) => {
                    console.debug(res)
                    dispatch(getMeasurements(createFilter()))
                })
        }
    }

    const handleImageError = (e) => {
        e.target.onerror = null;
        // e.target.style.display = 'none'
        e.target.src = "/assets/images/user.png"
    }

    return (
        <Fragment>
            <ContentBox>
                <Grid
                    container
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                    display="flex"
                >
                    <Grid item xs={12} sm={12} md={3}>
                        <SectionTitle>การตรวจ</SectionTitle>
                    </Grid>
                </Grid>
                {measurments.map((worker, id) => (
                    <Box>
                        <Card sx={{ display: 'flex', padding: '10px' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: 151 }}
                                image={"/api/common/picture/"+worker.cid}
                                onError={handleImageError}
                                alt={worker.name}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                }}
                            >
                                <CardHeader>
                                    <Stack direction="column" spacing={5}>
                                        <Typography
                                            component="div"
                                            variant="h6"
                                        >
                                            ข้อมูลผู้ปฏิบัติงาน
                                        </Typography>
                                        <dl style={{ margin: 0 }}>
                                            <Label>เลขประจำตัว</Label>
                                            <Data>{worker.cid}</Data>
                                            <Label>ชื่อ</Label>
                                            <Data>{worker.name}</Data>
                                            <Label>ตำแหน่งงาน</Label>
                                            <Data>{worker.work_title}</Data>
                                            <Label>สถานที่</Label>
                                            <Data>{worker.location}</Data>
                                            <Label>บริษัท</Label>
                                            <Data>{worker.company}</Data>
                                            <Label>สถานะ</Label>
                                            <Data>{worker.status}</Data>
                                        </dl>
                                    </Stack>
                                </CardHeader>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        pl: 1,
                                        pb: 1,
                                    }}
                                ></Box>
                            </Box>
                        </Card>
                        <Grid
                            container
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}
                            display="flex"
                        >
                            <Grid item xs={12} sm={12} md={3}>
                                <h4>รอบการทำงาน</h4>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={3}
                                sx={{ margin: 'auto 0' }}
                            >
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<Icon>science</Icon>}
                                    onClick={addMeasurmentShow}
                                >
                                    เพิ่มผลการตรวจ
                                </Button>
                                <AddMeasurementMenu
                                    open={addMeasurmentOpen}
                                    handleClose={addMeasurmentClose}
                                />
                            </Grid>
                        </Grid>

                        <Card overflow="auto">
                            <ProductTable>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ px: 3 }}>
                                            เวลาการตรวจ
                                        </TableCell>
                                        <TableCell sx={{ px: 0 }}>
                                            ชื่อการตรวจ
                                        </TableCell>
                                        <TableCell sx={{ px: 0 }}>
                                            ค่าที่ได้
                                        </TableCell>
                                        <TableCell sx={{ px: 0 }}>
                                            สถานะ
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {worker.measurements.map((item, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    px: 0,
                                                    textTransform: 'capitalize',
                                                }}
                                            >
                                                <TableData>
                                                    {new Date(
                                                        item.measurement_time
                                                    ).toLocaleTimeString()}
                                                </TableData>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{ px: 0 }}
                                            >
                                                <TableData>
                                                    {item.name}
                                                </TableData>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{ px: 0 }}
                                            >
                                                <TableData>
                                                    {item.value}
                                                </TableData>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{ px: 0 }}
                                            >
                                                <TableData>
                                                    {item.status}
                                                </TableData>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </ProductTable>
                        </Card>
                    </Box>
                ))}
            </ContentBox>
        </Fragment>
    )
}

export default UserInfo
